<script>
/**
 * Descripción: componente menú lateral
 *
 * @displayName TheMenu
 */

import { mapState, mapActions } from 'vuex';

import httpService from '@/services/httpService';

const BaseSkeletonLoader = () =>
  import('@/components/core/layouts/BaseSkeletonLoader');

const BaseDrawer = () => import('@/components/core/drawers/BaseDrawer');

export default {
  name: 'TheMenu',

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  components: {
    BaseSkeletonLoader,
    BaseDrawer
  },

  data() {
    return {
      options: null,
      loading: true,
      user: undefined
    };
  },

  computed: {
    /**
     * Status Global del menú close / open
     */
    ...mapState('navbar', ['status'])
  },

  mounted() {
    this.addOptions();
  },

  methods: {
    ...mapActions('navbar', ['changeStatus']),

    /**
     * Petición para traer el menú
     */
    addOptions() {
      httpService.get('/Menu/GetMenu').then(response => {
        if (response != undefined) {
          this.options = response.data['navBarModel'];
          this.user = response.data['userInformation'].userName;
          this.loading = false;
        }
      });
    }
  }
};
</script>

<template>
  <BaseDrawer :status="status">
    <div slot="container">
      <v-list-item>
        <v-list-item-content style="text-align: center;">
          <v-list-item-subtitle>
            <!-- @ Use: Vuex Usuario conectado -->
            <strong>{{ user }}</strong>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <!-- @ Use Loanding... -->
      <BaseSkeletonLoader v-if="loading" type="list-item" />
      <!-- @ Use Menú -->
      <v-list dense>
        <template v-for="item in options">
          <v-list-group
            v-if="item.childrens"
            :key="item.text"
            :prepend-icon="item.model ? item.icon : item['icon_alt']"
            append-icon
            link
          >
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list-item
              v-for="(child, i) in item.childrens"
              :key="i"
              :to="child.url"
            >
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ child.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item v-else :key="item.text" :to="item.url">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-list-item v-if="!show">
          <v-btn block @click="changeStatus" text color="primary">
            Cerrar
          </v-btn>
        </v-list-item>
      </v-list>
    </div>
  </BaseDrawer>
</template>

<style scope lang="sass">
.v-list-item__icon:first-child
  margin-right: 0px !important
.v-list-group__items
  margin-left: 40px !important
</style>
